import { useParams, Link } from "react-router-dom";
import { useApi } from "../lib/api";
import { shortAddr, fmtNum } from "../lib/format";
import { SectionHead, DataBadge, Skel, Empty, CopyBtn } from "../components/common";

export default function ExplorerBlock() {
  const { number } = useParams();
  const { data, loading } = useApi(`/explorer/blocks/${number}`);
  if (loading) return <Skel rows={10} h={36} />;
  if (!data?.live || !data.block) return <Empty msg="Block not found (or live data unavailable)." />;
  const b = data.block;
  return (
    <div className="space-y-4">
      <SectionHead title={`Block #${b.height}`} badge={<DataBadge live />} />
      <div className="t-card" data-testid="block-details">
        {[["Height", b.height], ["Timestamp", b.timestamp ? new Date(b.timestamp).toLocaleString() : "—"],
          ["Transactions", b.transactions_count ?? b.transaction_count], ["Gas Used", fmtNum(parseInt(b.gas_used || 0))],
          ["Gas Limit", fmtNum(parseInt(b.gas_limit || 0))], ["Size", `${fmtNum(b.size || 0)} bytes`],
          ["Sequencer / Miner", b.miner?.hash || "—"], ["Hash", b.hash], ["Parent Hash", b.parent_hash]].map(([l, v]) => (
          <div key={l} className="flex flex-col sm:flex-row px-3 py-2.5 border-b border-[#1a1a1a] last:border-0 text-[13px]">
            <span className="w-44 text-[#6B7280] shrink-0">{l}</span>
            <span className="num break-all">{v}{(l === "Hash" || l === "Sequencer / Miner") && v !== "—" && <CopyBtn text={String(v)} className="ml-1" />}</span>
          </div>
        ))}
      </div>
      {data.transactions?.length > 0 && (
        <>
          <SectionHead title="Transactions in Block" />
          <div className="t-card overflow-x-auto">
            <table className="w-full t-table" data-testid="block-txs-table">
              <thead><tr className="text-left border-b border-[#262626]"><th>Hash</th><th>Method</th><th>From</th><th>To</th><th className="text-right">Value</th></tr></thead>
              <tbody>
                {data.transactions.map((tx) => (
                  <tr key={tx.hash}>
                    <td><Link to={`/explorer/tx/${tx.hash}`} className="num text-xs text-[#10B981] hover:underline">{shortAddr(tx.hash, 6)}</Link></td>
                    <td className="text-xs text-[#9CA3AF]">{tx.method || "transfer"}</td>
                    <td className="num text-xs text-[#6B7280]">{shortAddr(tx.from?.hash || "")}</td>
                    <td className="num text-xs text-[#6B7280]">{shortAddr(tx.to?.hash || "")}</td>
                    <td className="text-right num text-xs">{(parseInt(tx.value || "0") / 1e18).toFixed(4)} ETH</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
